import ActiveDetailsScreen from 'features/lineOfCredit/screens/activeDetailsScreen/ActiveDetailsScreen';
import React from 'react';

export default function Page() {
  return <ActiveDetailsScreen />;
}
